var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { CustomInputForm } from '../../../components/Forms/CustomInputForm';
import { ShowContent } from '../../../components/ShowContent';
import { CustomCheckBox } from '../../../components/Forms/CustomCheckBox';
import { TextEditor } from '../../../components/TextEditor/TextEditor';
export var ViewTextField = function (_a) {
    var label = _a.label, value = _a.value, _b = _a.type, type = _b === void 0 ? 'text' : _b, InputProps = _a.InputProps, style = _a.style;
    var isText = useMemo(function () {
        return type === 'text';
    }, [type]);
    var isBool = useMemo(function () {
        return type === 'check';
    }, [type]);
    var isTextEditor = useMemo(function () {
        return type === 'text-editor';
    }, [type]);
    return (_jsxs(_Fragment, { children: [_jsx(ShowContent, __assign({ show: isText }, { children: _jsx(CustomInputForm, { style: { pointerEvents: 'none', cursor: 'default' }, InputProps: __assign({ readOnly: true }, InputProps), value: value || 'Não informado', label: label, fullWidth: true }) })), _jsx(ShowContent, __assign({ show: isBool }, { children: _jsx(CustomCheckBox, { style: { marginLeft: '-10px' }, checkboxProps: {
                        name: "".concat(label),
                        checked: value === 'true',
                    }, label: label }) })), _jsx(ShowContent, __assign({ show: isTextEditor }, { children: _jsx("div", __assign({ style: __assign({ display: 'flex', width: '100%' }, style) }, { children: _jsx(TextEditor, { showHeaderOptions: false, placeholder: "".concat(label), showImageButton: false, showListOptions: false, showCleanButton: false, showFontOptions: false, showLinkButton: false, disabled: true, value: value }) })) }))] }));
};
